import React from "react";
import PortfolioCSS from "../css/Portfolio.module.css";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

// Portfolio images removed
const images = [];

function Portfolio() {
  return (
    <div className={PortfolioCSS.gridContainer}>
      {images.map((src, index) => (
        <ImageWrapper key={index} src={src} index={index} />
      ))}
    </div>
  );
}

function ImageWrapper({ src, index }) {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  React.useEffect(() => {
    if (inView) {
      controls.start({ 
        opacity: 1,
        y: 0,
        scale: 1,
      });
    } else {
      controls.start({ 
        opacity: 0,
        y: 50,
        scale: 0.9,
      });
    }
  }, [controls, inView]);

  return (
    <motion.div
      ref={ref}
      animate={controls}
      initial={{ 
        opacity: 0,
        y: 50,
        scale: 0.9,
        rotateY: -15,
      }}
      transition={{ 
        duration: 0.8,
        delay: index * 0.1,
        ease: [0.22, 1, 0.36, 1],
      }}
      className={PortfolioCSS.imageWrapper}
      whileHover={{ 
        scale: 1.05,
        rotateY: 0,
        z: 50,
      }}
      style={{ perspective: "1000px" }}
    >
      <div className={PortfolioCSS.glowEffect}></div>
      <img
        src={src}
        alt={`Serenade Festival Event ${index + 1}`}
        className={PortfolioCSS.image}
        draggable="false"
        loading="lazy"
      />
    </motion.div>
  );
}

export default Portfolio;
